import React from "react";
import Form from 'react-bootstrap/Form';



import NavBar from "../NavBar/NavBar";
import filterAdd from "../../images/icons/filter-add.png";
import { AiOutlineSearch } from "react-icons/ai";

// import WallBoxTable from "./WallBoxTable";
import ChargeEventData from "./ChargeEventData";



import "./ChargeEvents.scss";


const ChargeEvents = () => {
    document.title = "Charge Event - POWERGrid Cloud"
    return (
        <>
            <NavBar />
            <main className="wrapper">
                <div className="page-content">
                    <div className="wallbox-area">
                        <div className="pages-title">
                            <div className="h2">Charging Events</div>
                            <span>Alle Ladungen in einer Übersicht </span>
                        </div>
                        <div className="search-filter">
                            <form action="">
                                <input type="text" placeholder="Search Product..." />
                                <button type="submit"><AiOutlineSearch /></button>
                            </form>
                            <div className="sort-date">
                                Sort by:
                                <Form.Select aria-label="Default select example">
                                    <option>Date Installed</option>
                                    <option value="1">Start Installed</option>
                                    <option value="2">Timestamp</option>
                                    <option value="3">Start Installed</option>
                                </Form.Select>
                            </div>
                            <div className="filter">
                                Filter <img alt="" src={filterAdd} />
                            </div>
                            <ul className="sort_check">
                                <li>
                                    <div className="check">
                                        <span className="close">&#10006;</span>
                                        <span>User: Jonas Mossler</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="check">
                                        <span className="close">&#10006;</span>
                                        <span>Konto: Geschäftlich</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="wallbox-tabl">
                            <ChargeEventData />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};


export default ChargeEvents;
